import { render } from "./JockeyPerformanceModal.vue?vue&type=template&id=2e035437&scoped=true"
import script from "./JockeyPerformanceModal.vue?vue&type=script&lang=js"
export * from "./JockeyPerformanceModal.vue?vue&type=script&lang=js"

import "./JockeyPerformanceModal.vue?vue&type=style&index=0&id=2e035437&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e035437"]])

export default __exports__